import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatINR } from "@/lib/api";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";
import { Badge } from "@/components/ui/badge";

export default function PublicSchemes() {
  const [schemes, setSchemes] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/schemes").then((r) => setSchemes(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);
  const central = schemes.filter((s) => (s.type || "").toLowerCase().includes("central") || (s.type || "").toLowerCase().includes("credit"));
  const state = schemes.filter((s) => (s.type || "").toLowerCase().includes("madhya"));

  const SchemeCard = ({ s }) => (
    <div className="p-6 rounded-lg border border-slate-200 bg-white card-hover" data-testid={`scheme-card-${s.code}`}>
      <div className="flex items-start justify-between gap-2">
        <div className="font-semibold text-slate-900 brand-heading leading-snug">{s.name}</div>
        <Badge variant="outline" className="text-[10px] shrink-0">{s.type}</Badge>
      </div>
      <div className="text-xs text-slate-500 mt-1">{s.nodal_department}</div>
      <p className="text-sm text-slate-700 mt-3 leading-relaxed">{s.description}</p>
      <div className="mt-4 grid grid-cols-2 gap-2 text-xs">
        <div><span className="text-slate-500">Benefit:</span><br /><span className="font-semibold">{s.benefit_type}</span></div>
        <div><span className="text-slate-500">Max cap:</span><br /><span className="font-semibold">{s.max_benefit_amount ? formatINR(s.max_benefit_amount) : "—"}</span></div>
      </div>
      <div className="mt-4 text-[11px] text-amber-800 bg-amber-50 border border-amber-200 rounded-md p-2">
        {s.disclaimer || "Verify against latest official notification before investment."}
      </div>
    </div>
  );

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
      <div className="text-xs uppercase tracking-widest text-slate-500 mb-2">Directory</div>
      <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 brand-heading" data-testid="schemes-heading">Government schemes</h1>
      <p className="mt-3 text-slate-600 max-w-2xl">Configurable directory of central and Madhya Pradesh MSME schemes. Rules and benefit formulas are demonstration configurations — verify against the latest official notification.</p>

      {loading ? (
        <div className="mt-12 text-slate-500">Loading schemes…</div>
      ) : (
        <>
          <section className="mt-12">
            <h2 className="text-2xl font-semibold text-slate-900 brand-heading mb-6">Central & credit-support schemes</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {central.map((s) => <SchemeCard key={s.id} s={s} />)}
            </div>
          </section>
          <section className="mt-16">
            <h2 className="text-2xl font-semibold text-slate-900 brand-heading mb-6">Madhya Pradesh schemes</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {state.map((s) => <SchemeCard key={s.id} s={s} />)}
            </div>
          </section>
        </>
      )}

      <div className="mt-16"><DisclaimerBanner /></div>
    </div>
  );
}
